import styled from 'styled-components';

import {
  InstructionText as DefaultInstructionText,
  LoadContainer as DefaultLoadContainer,
  ReloadExplanationText as DefaultReloadExplanationText,
  ReloadWrapper as DefaultReloadWrapper,
} from './styled.base';

export const ReloadWrapper = styled(DefaultReloadWrapper)`
  margin: 0;
`;

export const ReloadExplanationText = styled(DefaultReloadExplanationText)`
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  span {
    font-weight: 800;
  }
  ${Styles.desktop`
      margin: 1.5rem auto;
      font-size: 1rem;
  `}
`;

export const InstructionText = styled(DefaultInstructionText)`
  font-size: 1.5rem;
`;

export const LoadContainer = styled(DefaultLoadContainer)`
  margin-top: 0;

  > div {
    background-color: unset;
  }
`;
